var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-form',{staticClass:"main-navbar__search w-100 d-none d-md-flex d-lg-flex"},[_c('label',{staticClass:"ml-3 mt-3"},[_vm._v("\n        "+_vm._s(_vm.version)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }